<template>
    <div class="mylistwrap">
        <div v-if="infolist.length>0" class="mylist">
            <dl class="avg listheader" v-if="!issmall">
                <dd>{{$common.dicword('course')}}</dd>
                <dd>{{$common.dicword('title')}}</dd>
                <dd v-if="!islecture">{{$common.dicword('lecturer')}}</dd>
                <dd>{{$common.dicword('date')}}</dd>
                <dd>{{$common.dicword('time')}}</dd>
                <dd v-if="!isteaview&&c_options.schstat==1">{{$common.dicword('stat')}}</dd>
                <dd v-if="!isteaview">{{$common.dicword('participation')}}</dd>
                <dd v-if="isteaview">{{$common.dicword('learner')}}</dd>
            </dl>
            <div class="listinfo">
                <dl class="avg" v-for="item in c_infolist" :key="item.id">
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('course',true)}}&nbsp;
                        </span><router-link class="overparent" :to="item.x_course.x_root+item.courseid" :title="$common.langinfo(item.x_course.title,item.x_course.title_en)"><ffoverdot :title="item.x_course.title" :title_en="item.x_course.title_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('title',true)}}&nbsp;
                        </span><span :title="$common.langinfo(item.title,item.title_en)"><ffoverdot :title="item.title" :title_en="item.title_en" :needtitle="false"></ffoverdot></span>
                    </dd>
                    <dd v-if="!islecture">
                        <template v-if="issmall">
                            {{$common.dicword('lecturer',true)}}&nbsp;
                        </template>
                        {{item.x_teacher}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('date',true)}}&nbsp;
                        </span>
                        {{$common.basic.dateformat(item.datelecture)}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('time',true)}}&nbsp;
                        </span>
                        {{$common.basic.chint2time(item.timebegin/60) +'/'+$common.basic.chint2time(item.timeend/60)}}
                    </dd>
                    <dd v-if="!isteaview&&c_options.schstat==1">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('stat',true)}}&nbsp;
                        </span>
                        <a href="#" class="listbtn" v-if="item.x_iscansign" @click="signlecture(item.id)">{{$common.dicword(item.x_stat)}}</a>
                        <span v-else>{{$common.dicword(item.x_stat)}}</span>
                    </dd>

                    <dd v-if="!isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('participation',true)}}&nbsp;
                        </span>
                        <template v-if="item.x_isattend">
                            {{$common.basic.chint2time(item.x_timebegin/60) +'/'+$common.basic.chint2time(item.x_timeend/60)}}
                        </template>
                        <template v-else>
                            {{$common.dicword('notattend')}}
                        </template>
                    </dd>

                    <dd v-if="isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learner',true)}}&nbsp;
                        </span><fflearner :k="102" :options="{'lectureid':item.id}"></fflearner>
                    </dd>
                </dl>
            </div>

            <div class="ffpage">
                <el-pagination :small="issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                </el-pagination>
            </div>
        </div>

        <div class="memnorecord" v-if="c_infolist.length==0 && isload">{{$common.dicword('norecord')}}</div>
    </div>

</template>


<script>
    import { mixinsubpage } from "@/mixin/mixin";

    export default {
        name: 'Clecture',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tc_my_lecture',
            };
        },
        methods: {
            getdata: function () {

                this.$common.post(this.postjson, res => {
                    this.isload = true;
                    this.$common.each(res.infodatacourse, (item) => {
                        item.x_root = this.$common.tranlearnfolder(item.realtypekv);
                    });
                    this.$common.each(res.infodata, item => {
                        item.x_course = this.$common.basic.fffind(res.infodatacourse, 'id', item.courseid);
                        let _teacher = this.$common.basic.fffind(res.infodatateacher, 'id', item.lecturerid);
                        item.x_teacher = _teacher.showname || _teacher.realname || _teacher.username;

                        if (this.options.schstat == 2) {
                            item.x_isattend = item.isattend;
                            item.x_timebegin = item.memtimebegin;
                            item.x_timeend = item.memtimeend;
                        }
                        else {
                            if (this.options.schstat == 1 || this.isviewstu) {
                                let _memlecture = this.$common.basic.fffind(res.infodatamem, 'lectureid', item.id);
                                item.x_isattend = _memlecture.isattend;
                                item.x_timebegin = _memlecture.timebegin;
                                item.x_timeend = _memlecture.timeend;
                                if (this.$common.basic.isobjexist(_memlecture)) {
                                    item.x_iscansign = false;
                                    item.x_stat = '';
                                    switch (item.stat) {
                                        case 2:
                                            item.x_stat = 'registered';
                                            break;
                                        case 3:
                                            item.x_stat = 'isready';
                                            break;
                                        case 4:
                                            item.x_stat = 'running';
                                            break;
                                        case 9:
                                            item.x_stat = 'over';// (_memlecture.isattend) ? 'attended' : 'notattend';
                                            break;
                                    }
                                }
                                else {
                                    if (item.stat == 2) {
                                        item.x_iscansign = !this.isviewstu;
                                        item.x_stat = this.isviewstu ? 'registerno' : 'register';
                                    }
                                    else {
                                        item.x_iscansign = false;
                                        item.x_stat = 'registerno';
                                    }
                                }
                            }
                        }

                    });

                    this.infolist = res.infodata;
                    this.res = res;

                });
            },
            signlecture: function (id) {
                //this.$common.confirm(this.$common.dicword("注册课程后不可取消，确认要注册此课程吗？"), () => {
                let jsondata = {
                    'postdata': { 'act': 'tc_my_lecture_sign', 'id': id, 'msg': '' }
                };
                this.$common.post(jsondata, () => {
                    this.$nextTick(function () {
                        let _clecture = this.$common.basic.fffind(this.infolist, 'id', id);
                        _clecture.x_iscansign = false;
                        _clecture.x_stat = 'registered';
                    });

                });
                //});
            }

        }
    }
</script>
